import React from 'react';
import { makeStyles } from '@material-ui/core/styles'; 
import Speech from 'speak-tts';
import './InfoBox.css';
import { AudioButton } from './InfoBoxElements/AudioButton';
import { Content } from './InfoBoxElements/Content';
import Navigation, { NavigationProps } from './InfoBoxElements/Navigation';
import { MenuItem } from './SimpleMenu';

const speech = new Speech(); // will throw an exception if not browser supported
if (speech.hasBrowserSupport()) { // returns a boolean
  console.log("speech synthesis supported");
}
speech.init({ 'voice': 'Google US English' }).then((data: any) => {
  // The "data" object contains the list of available voices and the voice synthesis params
  // console.log("Speech is ready, voices are available", data);
}).catch((e: Error) => {
  console.error("An error occured while initializing : ", e);
});

const useStyles = makeStyles(theme => ({
  outerBox: {
    position: 'absolute',
    userSelect: 'auto',
    touchAction: 'none',
    width: '40%',
    top: 'calc(100px + 3%)',
    right: '2%',
    cursor: 'auto',
    zIndex: 404,
    backgroundColor: 'white',
    padding: '20px 21px',
    color: 'black',
    textAlign: 'left',
    boxShadow: 'rgba(0, 0, 0, 0.2) 9px 14px 15px 0px',
    minWidth: '410px',
    height: 'calc(100% - 175px - 3%)',
    boxSizing: 'border-box',
    flexShrink: 0,

    display: 'grid',
    gridTemplateColumns: '90% 10%',
    gridTemplateRows: 'auto auto 1fr auto',
    gridTemplateAreas: `'title audioButton'
                        'secondary secondary'
                        'content content'
                        'navigation navigation'`,
  },
  time: {
    marginLeft: '30px',
  },
  title: {
    fontFamily: 'OpenSans-Bold',
    fontSize: '22px',
    color: '#606060',
    width: '90%',
    paddingBottom: '0.5rem',
    gridArea: 'title',
  },
  secondaryLine: {
    fontFamily: 'OpenSans',
    fontSize: '14px',
    color: '#9D7E47',
    float: 'left',
    display: 'flex',
    paddingBottom: '0.5rem',
    gridArea: 'secondary',
  }
}));

interface InfoBoxProps {
  selectedImage: string | null;
  menuItems?: MenuItem[];
  navigationProps?: NavigationProps;
  textContentProps: { title: string; content: string; time?: string; latLong?: string };
}

export const InfoBox: React.FC<InfoBoxProps> = ({
  selectedImage,
  menuItems,
  navigationProps,
  textContentProps,
}) => {

  const classes = useStyles();

  return (
    <div id="box" className={classes.outerBox}>
      <AudioButton content={textContentProps.content} />
      <div className={classes.title}>{textContentProps.title}</div>
      {(textContentProps.latLong || textContentProps.time) && (
        <div className={classes.secondaryLine}>
          {textContentProps.latLong && <div>{textContentProps.latLong}</div>}
          {textContentProps.time && <div className="time">{textContentProps.time}</div>}
        </div>
      )}

      <Content
        content={textContentProps.content}
        menuItems={menuItems}
      />
      {navigationProps && <Navigation {...navigationProps}/>}
    </div>
  );
};

export default InfoBox;